import { TOKEN_KEY } from './authToken';
export const AUTH_SESSION_EXPIRED_EVENT = 'grand78:auth-session-expired';
export function expiredAuthQueryFromMessage(message) {
    if (!message)
        return undefined;
    if (message.includes('Пароль'))
        return 'password-changed=1';
    if (message.includes('Роль'))
        return 'role-changed=1';
    if (message.includes('отключён'))
        return 'inactive=1';
    return undefined;
}
export function clearClientSession() {
    localStorage.removeItem(TOKEN_KEY);
}
export function notifyAuthSessionExpired(detail) {
    window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, { detail }));
}
/** Сбрасывает клиентскую сессию и уведомляет UI (Header, редирект с /me и /admin). */
export function invalidateAuthSession(detail) {
    if (!localStorage.getItem(TOKEN_KEY))
        return;
    clearClientSession();
    notifyAuthSessionExpired(detail);
}
/** Проверка exp без валидации подписи — только для клиентского UX. */
export function isTokenExpired(token) {
    try {
        const payload = token.split('.')[1];
        if (!payload)
            return true;
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded.exp !== 'number')
            return false;
        return decoded.exp * 1000 <= Date.now();
    }
    catch {
        return true;
    }
}
export function isPublicAuthRequestUrl(url) {
    return /\/v1\/auth\/(login|register|verify|password-reset)(\/|$|\?)/.test(url);
}
